import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import "$styles/theme.css"
import "$styles/scroll-hint.css"
import "$styles/forms.css"

import "./navigation.js"
import "./scroll-hint.min.cjs"
import "./front-page.js"
import "./forms.js"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
